<template>
<div class="chapter">
<div class="inner_page">
<div class="bodyMatter">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<a id="page17"></a>
<h2 class="partTitle"><span class="xrefInternal"><a href="#/xhtml/contents#pt_01"><span class="bold">BLUEBERRY</span></a></span></h2>
<p class="centerImage"><img alt="image" src="images/pt01.jpg"/></p>
<p class="partSubtitle"><span class="xrefInternal"><a href="#/xhtml/contents#pt_01">NOTEBOOK</a></span></p></div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6c600d95